<template>
  <div class="wrap" >
    <span v-on:click="close" style="cursor: pointer; font-family: 'Rowdies', cursive; color: #fff; position: absolute; top: 20px; right: 20px; padding: 10px; font-size: 20px">close</span>
    <div class="container">
      <h2>Click here to go to spotify and start playing the playlist.</h2>
      <br />
      <p>Once your spotify is playing from the app and not paused, come back, and press the sync button to sync your audio with everyone.</p>
      <br />
      <br />
      <a style="padding: 14px; text-decoration: none; border-radius: 20; background-color: #1ed660; color: #fff" target="_blank" href="https://open.spotify.com/playlist/0HRjlYcjF9B6aU6VhugDtQ?si=UpiQvmviTCWPJ2mFa08mWw">
        OPEN SPOTIFY AND SYNC
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  data: function() {
    return {

    }
  },
  props: {
    visible: Boolean
  },
  methods: {
    close() {
      console.log('closing 1')
      this.$emit('close');
    }
  },
  created() {
    console.log('created the modal!')
  },
  mounted() {
    console.log('mpunted the modal!')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrap {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0, .8);
    /*background-color: rgba(0,0,0,.75);*/
    z-index: 300000000;

    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;

    top: 0px;
    left: 0px;
  }

  h1 {
    font-size: 50px;
  }

  p {
    font-family: Helvetica;
    font-size: 20px;
  }

  .btn {
    display: block;
    /*width: 300px;*/
    padding: 6px 24px;
    text-align: center;
    font-size: 30px;
    cursor: pointer;
    font-family: 'Rowdies', cursive;
  }

  .btn-fill {
    color: #000;
    background-color: #ffbb99;
    border: 4px solid #ffbb99;
    width: 100%;
  }

  .btn-fill:hover {
    opacity: .9;
  }

  .container {
    padding: 3.4rem; 
    text-align: center;
  }

  @media screen and (max-width: 500px) {
    .container {
      padding: 1rem;
    }
  }
</style>
